module.exports = __webpack_public_path__ + "img/zhaopin.eae3eae2.png";